import axios from 'axios';
import { AppStore } from '@apparatix/stores/AppStore';
const logoutUrl = '/logout';
const loginUrl = '/login';
export const useAppNavigation = () => {
    const syncOverflow = (el, shouldOverflow) => {
        const label = el?.innerText;
        if (!label)
            return;
        if (shouldOverflow) {
            const visibleIdx = AppStore.navigationItems.findIndex(item => item.label === label);
            if (visibleIdx !== -1) {
                const tmp = AppStore.navigationItems[visibleIdx];
                AppStore.navigationItems[visibleIdx].isOverflowing = true;
                el.style.opacity = '0';
                AppStore.overflowNavigation.unshift(tmp);
            }
            return;
        }
        const overflowIdx = AppStore.overflowNavigation.findIndex(item => item.label === label);
        if (overflowIdx !== -1) {
            AppStore.overflowNavigation.splice(overflowIdx, 1);
            el.style.opacity = '1';
        }
    };
    const showPageNotImplemented = () => {
        AppStore.shouldShowDashboard = false;
        AppStore.showPageNotImplemented = true;
        AppStore.setActiveUrl('');
    };
    const logOut = () => {
        axios.post(logoutUrl).then(() => window.location.href = loginUrl)
            .catch(() => window.location.href = loginUrl);
    };
    return {
        syncOverflow,
        showPageNotImplemented,
        logOut,
    };
};
